import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestSection() {
  const latest = [...articles].sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );
  const exclusiveArticles = latest.filter((a) => a.isExclusive).slice(0, 3);
  const regularArticles = latest.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-950">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          {/* Main article list */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6 md:mb-8">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500/20 text-secondary-400">
                <i className="ri-time-line" />
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-100">最新爆料</h2>
            </div>

            <div className="space-y-4 md:space-y-5">
              {regularArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex gap-3 md:gap-4 p-3 md:p-4 rounded-xl bg-background-900 border border-background-800/50 hover:border-primary-500/30 transition-all"
                >
                  <div className="w-28 h-20 md:w-36 md:h-24 rounded-lg overflow-hidden shrink-0">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 min-w-0 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-xs text-primary-400 font-medium">
                          {article.categoryName}
                        </span>
                        {article.isExclusive && (
                          <span className="px-1.5 py-0.5 rounded bg-primary-500/20 text-primary-300 text-[10px] font-bold">
                            独家
                          </span>
                        )}
                        {article.isHot && (
                          <span className="px-1.5 py-0.5 rounded bg-accent-500/20 text-accent-300 text-[10px] font-bold">
                            热
                          </span>
                        )}
                      </div>
                      <h3 className="text-sm md:text-base font-bold text-foreground-200 group-hover:text-primary-300 transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-foreground-600">
                      <span>{article.publishDate}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {(article.views / 10000).toFixed(1)}万
                      </span>
                      <span className="hidden sm:inline">{article.author}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="mt-6 md:mt-8 text-center">
              <Link
                to="/category/daily-gossip"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-700 text-sm text-foreground-400 hover:text-primary-300 hover:border-primary-500/30 transition-colors"
              >
                加载更多爆料 <i className="ri-arrow-down-line" />
              </Link>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1">
            {/* Exclusive */}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-400">
                  <i className="ri-vip-crown-line" />
                </div>
                <h3 className="text-lg font-bold text-foreground-100">独家猛料</h3>
              </div>
              <div className="space-y-3">
                {exclusiveArticles.map((article, index) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group flex gap-3 p-3 rounded-lg bg-background-900 border border-background-800/50 hover:border-primary-500/30 transition-all"
                  >
                    <span className="w-6 h-6 flex items-center justify-center rounded bg-primary-500 text-background-50 text-xs font-bold shrink-0">
                      {index + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-foreground-300 group-hover:text-primary-300 transition-colors line-clamp-2">
                        {article.title}
                      </h4>
                      <span className="text-xs text-foreground-600 mt-1 block">
                        {(article.views / 10000).toFixed(1)}万阅读
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* Hot tags */}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-500/20 text-accent-400">
                  <i className="ri-price-tag-3-line" />
                </div>
                <h3 className="text-lg font-bold text-foreground-100">热门标签</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {[
                  '出轨', '税务', '假唱', '塌房', '整容', '校园霸凌',
                  '选秀造假', '洗钱', '抄袭', '学历造假', '带货翻车',
                  '性骚扰', '剧本', '片酬', '替身', '网红', '综艺',
                ].map((tag) => (
                  <Link
                    key={tag}
                    to="/category/daily-gossip"
                    className="px-3 py-1.5 rounded-full bg-background-900 border border-background-800/50 text-xs text-foreground-400 hover:text-accent-300 hover:border-accent-500/30 transition-colors"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}